import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/shared/ui/dropdown-menu';
import type { SupportedLocale } from '@/i18n';

const languages = [
  { code: 'en' as SupportedLocale, name: 'English', flag: '🇬🇧', shortCode: 'EN' },
  { code: 'de' as SupportedLocale, name: 'Deutsch', flag: '🇩🇪', shortCode: 'DE' },
];

export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();

  const setLanguage = (lng: SupportedLocale) => {
    i18n.changeLanguage(lng);
  };

  const currentLanguage = languages.find(lang => i18n.language?.startsWith(lang.code)) || languages[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          size="sm" 
          className="h-9 gap-2 px-2 sm:px-3" 
          aria-label={t('app.language')}
        >
          <span className="text-lg" role="img" aria-label={currentLanguage.name}>
            {currentLanguage.flag}
          </span>
          <span className="hidden sm:inline font-medium">{currentLanguage.shortCode}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {languages.map((lang) => (
          <DropdownMenuItem 
            key={lang.code}
            onClick={() => setLanguage(lang.code)}
            className="gap-3 cursor-pointer"
          >
            <span className="text-lg" role="img" aria-label={lang.name}>
              {lang.flag}
            </span>
            <span className="flex-1">{lang.name}</span>
            {i18n.language?.startsWith(lang.code) && (
              <span className="text-emerald-600">✓</span>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
